import { useContext } from 'react';

import { MediaitemUploadService } from '@services/mediaitemUploadService';
import { MediaitemUploadServiceContext } from '@shared/BackgroundActivityContext';

export function useMediaitemUploadService(): MediaitemUploadService {
  const ctx = useContext(MediaitemUploadServiceContext);
  if (!ctx) {
    throw new Error('useMediaitemUploadService: missing <BackgroundActivityProvider>');
  }
  return ctx;
}
